import { Box, Flex, Icon, Tab, TabList } from '@chakra-ui/react'
import React from 'react'
import iconCalls from '~/assets/svgs/icon-calls.svg?react'
import iconMessaging from '~/assets/svgs/icon-messaging.svg?react'
import mangoIcon from '~/assets/svgs/mango-m.svg'
import { ImageIcon } from '~/components/ImageIcon'
import { NotificationBadgeVariant } from '~/components/shared/componentStyles/NotificationBadge.style'
import { NotificationBadge } from '~/components/shared/NotificationBadge'
import { useMainWindow, usePopupWindow } from '~/hooks/useElectronWindow'
import { PopupStyle } from '~/pages/Popup/componentStyles/Popup.style'
import { QueueMeta } from '~/pages/Popup/PopupPage'
import { Size } from '~/types/ThemeTypes'

const CustomBadge = (props: { count: number | undefined }) => {
  const { count } = props

  return (
    <NotificationBadge
      style={{ position: 'absolute', top: 0, right: 4 }}
      size={Size.xs}
      variant={NotificationBadgeVariant.Popup}
      count={count}
    />
  )
}

export const PopupHeader = (props: {
  meta: QueueMeta
  branding?: 'icon' | 'logo'
}) => {
  const { meta, branding = 'logo' } = props
  const { focusMainWindow } = useMainWindow()
  const { hidePopupWindow } = usePopupWindow()

  const handleLogoClick = () => {
    focusMainWindow()

    if (meta.calls.count === 0 && meta.messages.count === 0) {
      hidePopupWindow()
    }
  }

  return (
    <Flex
      direction="row"
      flex="1"
      justifyContent={'space-between'}
      alignItems={'flex-start'}
      marginBottom={1}
    >
      <TabList>
        <Tab style={{ position: 'relative', marginRight: 6 }}>
          <Icon
            filter={meta.calls.count > 0 ? undefined : 'opacity(0.25)'}
            as={iconCalls}
          />
          {meta.calls.count > 0 && (
            <CustomBadge count={meta.calls.count > 0 ? 1 : undefined} />
          )}
        </Tab>
        <Tab style={{ position: 'relative' }}>
          <Icon
            filter={meta.messages.count > 0 ? undefined : 'opacity(0.25)'}
            as={iconMessaging}
          />
          {meta.messages.count > 0 && (
            <CustomBadge count={meta.messages.count} />
          )}
        </Tab>
      </TabList>
      <>
        {branding === 'logo' ? (
          <Flex
            onClick={handleLogoClick}
            sx={PopupStyle?.baseStyle?.logoWrapper || {}}
          >
            <Box sx={PopupStyle?.baseStyle?.logo || {}} />
          </Flex>
        ) : (
          <ImageIcon
            icon={mangoIcon}
            width={24}
            height={24}
            cursor
            onClick={handleLogoClick}
          />
        )}
      </>
    </Flex>
  )
}
